import { render, staticRenderFns } from "./CentralNotificacoes.vue?vue&type=template&id=141e3d6c"
import script from "./CentralNotificacoes.vue?vue&type=script&lang=ts"
export * from "./CentralNotificacoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports